module.exports = __webpack_public_path__ + "static/img/enter3.21b60bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enter3.jpg
// module id = FKdn
// module chunks = 1